export function XML_SetTextColor(theColor, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputSimpleElement("tc", theColor, s);
}
